/** Progressive enhancement of the normal GET form; never opens on typing. */
class MuuvHeaderSearchBridge extends HTMLElement {
  #controller;

  async connectedCallback() {
    this.#controller?.abort();
    const controller = new AbortController();
    this.#controller = controller;
    const { signal } = controller;
    await Promise.all([
      customElements.whenDefined('dialog-component'),
      customElements.whenDefined('predictive-search-component'),
    ]);
    if (signal.aborted || !this.isConnected) return;
    const dialog = document.getElementById('search-modal');
    const predictive = dialog?.querySelector('predictive-search-component');
    const input = this.querySelector('input[type="search"]');
    const button = this.querySelector('[data-muuv-search-suggestions]');
    const modalInput = predictive?.querySelector('[ref="searchInput"]');
    if (!input || !button || !modalInput || typeof predictive.prepareQuery !== 'function' || typeof dialog.showDialog !== 'function') return;

    // The existing on:click="#search-modal/showDialog" handler remains the only
    // opener. This element merely seeds its input and manages the return focus.
    button.addEventListener('click', () => {
      predictive.prepareQuery(input.value);
      dialog.addEventListener('dialog:open', () => modalInput.focus(), { once: true, signal });
      dialog.addEventListener('dialog:close', () => {
        if (this.isConnected) button.focus({ preventScroll: true });
      }, { once: true, signal });
    }, { signal });
    button.hidden = false;
  }

  disconnectedCallback() {
    this.#controller?.abort();
    const button = this.querySelector('[data-muuv-search-suggestions]');
    if (button) button.hidden = true;
  }
}

if (!customElements.get('muuv-header-search-bridge')) {
  customElements.define('muuv-header-search-bridge', MuuvHeaderSearchBridge);
}
